'use strict';

var getS3BucketFromDomain = require('./getS3BucketFromDomain');
var generateCanonicalS3Domain = require('./generateCanonicalS3Domain');

var getCanonicalDomain = function getCanonicalDomain(domain) {
    var bucket = getS3BucketFromDomain(domain);
    if (bucket !== null) {
        return generateCanonicalS3Domain(bucket);
    } else {
        return null;
    }
};

module.exports = {
    getCanonicalDomain: getCanonicalDomain
};